import React from 'react'
import PropTypes from 'prop-types'

import { Heading, Square } from 'Components/Blocks/_Legacy'
import { Motion, Wrapper } from 'Components/UI'

import processGlyph from 'Assets/_Legacy/Svg/process.svg'

import { PathVerticalLong } from './RoadMap/paths'
import RoadMap from './RoadMap'
import { Container, Content, StepsWrapper } from './styles'

function Process({ data, rendered }) {
  return (
    <Container>
      <Wrapper>
        <Content>
          <Motion>
            <Heading
              subTitleText={data.subtitleText}
              tagGlyph={processGlyph}
              tagText={data.overheadText}
              titleText={{
                first: {
                  text: data.titleTextFirst,
                  bold: data.firstBold,
                },
                second: {
                  text: data.titleTextSecond,
                  bold: data.secondBold,
                },
              }}
            />
          </Motion>

          <StepsWrapper>
            <PathVerticalLong display={['flex', 'flex', 'none']} />

            <RoadMap data={data.steps} rendered={rendered} />
          </StepsWrapper>
        </Content>
      </Wrapper>

      <Square
        angle={-30}
        horizontalAlign={[-550, null]}
        verticalAlign={[900, null]}
      />

      <Square
        angle={15}
        horizontalAlign={[null, -500]}
        verticalAlign={[400, null]}
      />
    </Container>
  )
}

Process.defaultProps = {
  data: {},
  rendered: false,
}

Process.propTypes = {
  data: PropTypes.object,
  rendered: PropTypes.bool,
}

export default Process
